import React from 'react';
import { useSelector } from 'react-redux';
import { colors } from '@/globalStyles';
import { getShapeFill } from '@/helpers';
import { STROKE_DASHARRAY, STROKE_WIDTH } from '@/constants';

const Scissors = props => {
  const { section, shield, rectProps, isShieldSelected, sectionBorderColor } = props;
  const paperColor = useSelector(state => state.core.paperColor);
  const isGridDisplayed = useSelector(state => state.core.isGridDisplayed);
  const rectWidth = rectProps.width <= 15 ? rectProps.width - 2 : 15;
  const rectHeight = 10;
  const rectX = rectProps.x + rectProps.width / 2 - rectWidth / 2;
  const rectY = rectProps.y + rectProps.height - rectHeight / 2;
  const svgWidth = 5;
  const svgHeight = 5;
  const svgX = rectX + rectWidth / 2 - svgWidth / 2;
  const svgY = rectY + rectHeight / 2 - 2;

  const shapeFill = getShapeFill({
    shapeRendererAdditProps: { paperColor },
    shapeObj: shield,
    isSelected: isShieldSelected,
    isGridDisplayed,
  });
  const secondLayerReactFill = isShieldSelected ? colors.paternoster : 'none';

  return (
    <g id="scissors">
      <rect className={`${section.id}_scissors-shell`} x={rectX} y={rectY} width={rectWidth} height={rectHeight} fill={shapeFill}></rect>
      <rect x={rectX} y={rectY} width={rectWidth} height={rectHeight} fill={secondLayerReactFill}></rect>
      <svg x={svgX} y={svgY} width={svgWidth} height={svgHeight} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#aqbflfy14a)">
          <path
            d="M11.381 10.41 7.82 7.38a.375.375 0 0 1 .488-.572l3.562 3.031c.157.134.175.37.042.53a.377.377 0 0 1-.53.042zm.003-8.822a.374.374 0 1 1 .483.574l-6.98 5.88A2.624 2.624 0 0 1 2.625 12a2.624 2.624 0 1 1 0-5.251c.691 0 1.322.267 1.79.705L6.146 6l-1.73-1.455A2.624 2.624 0 1 1 2.626 0a2.624 2.624 0 0 1 2.262 3.959l1.84 1.551 4.657-3.922zM.75 2.625a1.875 1.875 0 1 0 3.75 0 1.875 1.875 0 0 0-3.75 0zm1.875 8.625a1.875 1.875 0 1 0 .001-3.749 1.875 1.875 0 0 0-.001 3.749z"
            fill={sectionBorderColor}
          ></path>
        </g>
        <defs>
          <clipPath id="aqbflfy14a">
            <path fill="#fff" d="M0 0h12v12H0z"></path>
          </clipPath>
        </defs>
      </svg>
    </g>
  );
};

const getSectionStyles = data => {
  const { isSectionHovered, isSectionSelected, isEditModeEnabled, shield, section, scaleCoef } = data;
  const isMatrix = !!shield?.isMatrix;
  const strokeDasharray = STROKE_DASHARRAY;
  const strokeWidth = 3 / scaleCoef;

  if (isMatrix) {
    if (isSectionSelected) {
      return { stroke: colors.transparent };
    }
    return { stroke: colors.transparent };
  } else if (isSectionSelected) {
    if (isEditModeEnabled) {
      return { stroke: colors.primary, strokeDasharray, strokeWidth: STROKE_WIDTH };
    }
    return { stroke: colors.primary, strokeWidth };
  } else {
    if (isSectionHovered) {
      return { stroke: colors.primary, strokeWidth };
    } else if (section.isChanged) {
      return { stroke: colors.dimGray, strokeDasharray, strokeWidth: STROKE_WIDTH };
    }
    return { stroke: colors.transparent };
  }
};

const SectionArea = props => {
  const { section, shield, rectProps, isSectionSelected, isSectionHovered } = props;
  const scaleCoef = useSelector(state => state.core.scaleCoef);
  const shieldsSelection = useSelector(state => state.core.shieldsSelection);
  const floatableInputVisible = useSelector(state => state.core.floatableInputVisible);
  const isEditModeEnabled = floatableInputVisible;
  const { x, y, width, height } = rectProps;
  const isShieldSelected = shieldsSelection[shield?.id];
  const isScissorsAvailable = !!section?.laserOutputQuality?.cutout;
  const additionalStyles = getSectionStyles({
    isSectionHovered,
    isSectionSelected,
    isEditModeEnabled,
    shield,
    section,
    scaleCoef,
  });
  const style = {
    fill: 'transparent',
    ...additionalStyles,
  };

  return (
    <>
      <rect
        id={section.id}
        style={style}
        className="section-area"
        x={x}
        y={y}
        width={width}
        height={height}
      />
      {isScissorsAvailable && (
        <Scissors
          section={section}
          shield={shield}
          rectProps={rectProps}
          isShieldSelected={isShieldSelected}
          sectionBorderColor={additionalStyles.stroke}
        />
      )}
    </>
  );
};

export default SectionArea;
